<div class="filter-container" id="payment-filter-id">
  <div class="search-filter">
    <input type="text" placeholder="{{ 'COMMON.Search' | translate }}" />
  </div>
  <div class="saved-filter">
    @if (savedFilter?.deal_type?.length) {
      <span class="d-flex flex-wrap">
        @for (
          sfilter of savedFilter?.deal_type;
          track sfilter;
          let i = $index
        ) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)"> {{ sfilter?.name }} </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="removeFilter(sfilter?.id, 'deal_type')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }

    @if (savedFilter?.activity?.length) {
      <span class="d-flex flex-wrap">
        @for (sfilter of savedFilter?.activity; track sfilter; let i = $index) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)"> {{ sfilter?.name }} </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="removeFilter(sfilter?.id, 'activity')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }
    @if (savedFilter?.organization?.length) {
      <span class="d-flex flex-wrap">
        @for (
          sfilter of savedFilter?.organization;
          track sfilter;
          let i = $index
        ) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)"> {{ sfilter?.name }} </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="removeFilter(sfilter?.id, 'organization')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }

    @if (savedFilter?.tags?.length) {
      <span class="d-flex flex-wrap">
        @for (sfilter of savedFilter?.tags; track sfilter; let i = $index) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)"> {{ sfilter?.name }} </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="removeFilter(sfilter?.id, 'tags')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }

    @if (savedFilter?.deal_stage?.length) {
      <span class="d-flex flex-wrap">
        @for (
          sfilter of savedFilter?.deal_stage;
          track sfilter;
          let i = $index
        ) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)"> {{ sfilter?.name }} </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="removeFilter(sfilter?.id, 'deal_stage')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }
    @if (savedFilter?.customFields) {
      <span class="d-flex flex-wrap">
        @for (
          sfilter of savedFilter?.customFields;
          track sfilter;
          let i = $index
        ) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)"> {{ sfilter?.name }} </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="removeFilter(sfilter?.id, 'customFields')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }

    @if (savedFilter?.status?.length) {
      <span class="d-flex flex-wrap">
        @for (sfilter of savedFilter?.status; track sfilter; let i = $index) {
          <mat-chip
            class="m-1 filter-input tag-input flex items-center"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)">
              {{
                getTranslatedText('QUOTE_TEMPLATE.' + sfilter?.name) ||
                  sfilter?.name
              }}
            </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                class="!h-[18px]"
                (click)="removeFilter(sfilter?.id, 'status')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }
    @if (savedFilter?.document_type?.length) {
      <span class="d-flex flex-wrap">
        @for (
          sfilter of savedFilter?.document_type;
          track sfilter;
          let i = $index
        ) {
          <mat-chip
            class="m-1 filter-input tag-input flex items-center"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)">
              {{
                getTranslatedText('COMMON.' + sfilter?.name) || sfilter?.name
              }}
            </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                class="!h-[18px]"
                (click)="removeFilter(sfilter?.id, 'document_type')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }
    @if (savedFilter?.member?.length) {
      <span class="d-flex flex-wrap">
        @for (sfilter of savedFilter?.member; track sfilter; let i = $index) {
          <mat-chip
            class="m-1 filter-input tag-input flex items-center"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)">
              {{
                getTranslatedText(
                  'QUOTE_TEMPLATE.' +
                    sfilter?.first_name +
                    ' ' +
                    sfilter?.last_name
                ) || sfilter?.first_name + ' ' + sfilter?.last_name
              }}
            </a>
            @if (removable) {
              <mat-icon
                matChipRemove
                class="!h-[18px]"
                (click)="removeFilter(sfilter?.id, 'member')"
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }

    @if (savedFilter) {
      <span class="d-flex flex-wrap">
        @if (savedFilter?.singale_value) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)">{{ savedFilter?.singale_value }}</a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="
                  removeFilter(savedFilter?.singale_value, 'singale_value')
                "
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
        @if (savedFilter?.slider_value && savedFilter?.slider_value != '0-0') {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)">{{ savedFilter?.slider_value }}</a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="
                  removeFilter(savedFilter?.slider_value, 'slider_value')
                "
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
        @if (savedFilter?.singale_date) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)">{{
              savedFilter?.singale_date | customDate
            }}</a>
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="
                  removeFilter(savedFilter?.singale_date, 'singale_date')
                "
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
        @if (savedFilter?.from_to_date) {
          <mat-chip
            class="m-1 filter-input tag-input"
            [selectable]="selectable"
            [removable]="removable"
          >
            <a href="javascript:void(0)"
              >{{ savedFilter?.from_to_date.split(' to ')[0] | customDate }} to
              {{ savedFilter?.from_to_date.split(' to ')[1] | customDate }}</a
            >
            @if (removable) {
              <mat-icon
                matChipRemove
                (click)="
                  removeFilter(savedFilter?.from_to_date, 'from_to_date')
                "
              >
                close
              </mat-icon>
            }
          </mat-chip>
        }
      </span>
    }
  </div>
  <div class="h-[300px] overflow-y-auto">
    <div class="acordion-filed">
      <mat-accordion>
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'PAYMENTS.Status' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="acordion-search">
            <input
              class="acordion-search-input"
              [placeholder]="'PAYMENTS.SearchStatus' | translate"
              [(ngModel)]="statusSearchTags"
            />
          </div>
          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (
                  item of paymentStatusArr | search: statusSearchTags;
                  track item
                ) {
                  <p class="!h-[28px]">
                    <mat-checkbox
                      [checked]="checkValueExist(savedFilter?.status, item.id)"
                      (change)="getAccorValue($event, item, 'status')"
                    >
                      {{
                        getTranslatedText('COMMON.' + item?.name) || item?.name
                          | uppercase
                      }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'PAYMENTS.Members' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="acordion-search">
            <input
              class="acordion-search-input"
              [placeholder]="'PAYMENTS.SearchMembers' | translate"
              [(ngModel)]="contactSearchTags"
            />
          </div>
          <div class="acordion-input">
            <!-- (scroll)="onScroll($event)" -->
            <span class="example-list-section">
              <span>
                @for (
                  item of merContactListArr | search: contactSearchTags;
                  track item
                ) {
                  <p class="!h-[28px]">
                    @if (
                      item?.fname !== null &&
                      item?.fname !== undefined &&
                      item?.fname !== ''
                    ) {
                      <mat-checkbox
                        [checked]="
                          checkValueExistMember(savedFilter?.member, item)
                        "
                        (change)="getAccorValue($event, item, 'member')"
                        >{{ item?.fname || '' }} {{ item?.lname || '' }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'PAYMENTS.Organization' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="acordion-search">
            <input
              class="acordion-search-input"
              [placeholder]="'PAYMENTS.SearchOrganization' | translate"
              [(ngModel)]="searchTags"
            />
          </div>
          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of allOrgArr | search: searchTags; track item) {
                  <p class="!h-[28px]">
                    <mat-checkbox
                      [checked]="
                        checkValueExist(savedFilter?.organization, item.id)
                      "
                      (change)="getAccorValue($event, item, 'organization')"
                      >{{ item?.name }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'QUOTE_TEMPLATE.Document Type' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="acordion-search">
            <input
              class="acordion-search-input"
              [placeholder]="'COMMON.Search' | translate"
              [(ngModel)]="docTypeSearchTags"
            />
          </div>
          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (
                  item of docTypeArr | search: docTypeSearchTags;
                  track item
                ) {
                  <p class="!h-[28px]">
                    <mat-checkbox
                      [checked]="
                        checkValueExist(savedFilter?.document_type, item.id)
                      "
                      (change)="getAccorValue($event, item, 'document_type')"
                      >{{
                        getTranslatedText('COMMON.' + item?.name) || item?.name
                      }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="value-range-field">
      <div class="value-field">
        <label for="singale_value">{{
          'PAYMENTS.Provide an Amount' | translate
        }}</label>
        <input
          type="number"
          id="singale_value"
          class="value-input"
          [(ngModel)]="savedFilter.singale_value"
          (input)="
            getAccorValue($event, savedFilter.singale_value, 'singale_value')
          "
        />
      </div>
      <div class="range-field">
        <label for="range_value">{{ 'COMMON.Select_Range' | translate }}</label>
        <div class="range-input" id="range_value">
          <ngx-slider
            [(value)]="sliderValue"
            [(highValue)]="sliderMaxValue"
            [options]="sliderOptions"
            (valueChange)="getAccorValue($event, '', 'slider_value')"
          >
          </ngx-slider>
        </div>
      </div>
    </div>

    <div class="date-field">
      <div class="single-date-field">
        <label for="single_date">{{ 'COMMON.Date' | translate }}</label>
        <app-custom-date
          id="single_date"
          (updateValue)="getAccorValue($event, 'singaledate', 'singale_date')"
          dataType="4"
          inputType="date"
          fvalue="{{ savedFilter.singale_date }}"
          class="single-date-input"
        >
        </app-custom-date>
      </div>
      <div class="fromto-date-field">
        <div class="from-date-field">
          <label for="start_date">{{ 'COMMON.From' | translate }}</label>
          <app-custom-date
            id="start_date"
            (updateValue)="getAccorValue($event, 'fromtodate', 'start_date')"
            dataType="4"
            maxDate="{{ savedFilter.end_date }}"
            inputType="date"
            fvalue="{{ savedFilter.start_date }}"
            class="from-date-input"
          >
          </app-custom-date>
        </div>
        <div class="to-date-field">
          <label for="end_date">{{ 'COMMON.To' | translate }}</label>
          <app-custom-date
            id="end_date"
            (updateValue)="getAccorValue($event, 'fromtodate', 'end_date')"
            dataType="4"
            minDate="{{ savedFilter.start_date }}"
            inputType="date"
            fvalue="{{ savedFilter.end_date }}"
            class="to-date-input"
          >
          </app-custom-date>
        </div>
      </div>
    </div>
  </div>
  <div class="apply-filter-field">
    <div class="clear-filter-btn">
      <button type="button" (click)="resetFilter()">
        <app-custom-icon icon="round_close"></app-custom-icon>
        {{ 'COMMON.Cancel_Filter' | translate }}
      </button>
    </div>
    <div class="apply-filter-btn">
      <button type="button" (click)="saveFilter()">
        <app-custom-icon icon="round_correct"></app-custom-icon>
        {{ 'COMMON.Apply_Filter' | translate }}
      </button>
    </div>
  </div>
</div>
